import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { clientTypes } from "../../../../../Utils/GlobalVariables/Crm/ClientTypes";
import BMXAutocomplente from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import { useContacts } from "../../../../../Hooks/useContactsHook/useContacts";

import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";

const NotifyUserFormStepOne = (props) => {
  const { update, initialValues } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [contacts, setContacts] = useState([]);
  const { getContactData } = useContacts();

  const { values, form } = props;

  const loadData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByName/${searchTerm}`,
      });
      const [contactListPayload] = await Promise.all([data]);
      const contactList = contactListPayload?.payload?.data?.map((contact) => {
        return {
          uuid: contact.uuid,
          value: `${contact.name}`,
          ...contact,
        };
      });

      if (contactList?.length > 0) {
        setContacts(contactList);
        return contactList;
      } else {
        setContacts([]);
        return [];
      }
    }
  };

  // useEffect(() => {
  //   const fetchData = async () => {};
  //   fetchData();
  // }, []);

  return (
    <div className="SecretFormStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:client.basicInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXAsynchronous}
            label={t("global:notifyUser.contact")}
            name="contact"
            data-cy="contact"
            options={contacts}
            currentValues={values}
            getOptionLabel={(option) => option?.name || option}
            getData={loadData}
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXTextField}
            name="firstName"
            label={t("global:notifyUser.firstName")}
            data-cy="firstName"
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXTextField}
            name="lastName"
            label={t("global:notifyUser.lastName")}
            data-cy="lastName"
          />
        </Col>

        <Col xs={12}>
          <Field
            component={BMXTextField}
            name="login"
            label={t("global:notifyUser.login")}
            data-cy="login"
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXTextField}
            name="password"
            label={t("global:notifyUser.password")}
            type="password"
            data-cy="password"
            autoComplete="new-password"
          />
        </Col>

        <Col xs={6}>
          <Field
            component={BMXTextField}
            name="repeatPassword"
            autoComplete="new-password"
            label={t("global:notifyuser.repeatPassword")}
            type="password"
            data-cy="repeatPassword"
          />
        </Col>

        <Col xs={3}>
          <Field
            className="mt-0"
            name="notifyRole"
            component={BMXSelectField}
            values={[
              { value: "USER", name: t("global:notifyuser.user") },
              { value: "ADMIN", name: t("global:notifyuser.admin") },
            ]}
            label={t("global:notifyuser.notifyRole")}
          />
        </Col>

        <Col xs={3}>
          <Field
            component={BMXTextField}
            fieldtype="checkbox"
            className="mt-1"
            name="blocked"
            label={t("global:notifyuser.blocked")}
            data-cy="blocked"
          />
        </Col>

        <Col xs={12}>
          <Field
            component={BMXTextField}
            name="comments"
            label={t("global:notifyuser.comments")}
            data-cy="comments"
            multiline
            maxRows={4}
          />
        </Col>
      </Row>
    </div>
  );
};

export default NotifyUserFormStepOne;
